import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const Customsoso = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();
  const handleClicked = () => {
    navigate("/contact");
  };

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const features1 = [
    {
      img: "/images/image 117 (1).webp",
      bgImg: "/images/bg1.webp",
      title: "Research",
      description:
        "Research in web development involves analyzing user behavior, industry trends, and technology to create efficient, user-friendly, and innovative digital experiences."
    },
    {
      img: "/images/image 86.webp",
      bgImg: "/images/bg2.webp",
      title: "Customize a design",
      description:
        "Crafting a website design involves blending aesthetics, usability, and functionality to create visually appealing, responsive, and user-friendly digital experiences that engage and convert visitors."
    },
    {
      img: "/images/image 117 (2).webp",
      bgImg: "/images/bg3.webp",
      title: "Customize a Coding",
      description:
        "Customizing a Coding based on design in web development involves translating visual concepts into functional, responsive, and interactive websites using HTML, CSS, JavaScript, and frameworks."
    },
    {
      img: "/images/image 117 (3).webp",
      bgImg: "/images/bg4.webp",
      title: "Testing the end product",
      description:
        "Testing the end product in web development ensures functionality, performance, security, and user experience by identifying and fixing bugs before deployment."
    },
    {
      img: "/images/image 117 (4).webp",
      bgImg: "/images/bg4.webp",
      title: "Launching a website",
      description:
        "Launching a website involves deploying code, configuring servers, optimizing performance, ensuring security, and promoting it for users to access seamlessly online."
    }
  ];
  return (
    <>
      <section className="websection">
        <div className="coso">
        <motion.h2
            className="websection2"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >Custom software solution in salem </motion.h2>
          <motion.p
            className="fsp websection3"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8, ease: "easeOut" }}
          >
            We delivers a custom software solutions to your business needs,
            enhancing efficiency, innovation, and growth with cutting-edge
            technology.
            </motion.p>
            <motion.button
            className="uiuxbutton"
            onClick={handleClicked}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1, duration: 0.5 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >Let's talk &#8594;          </motion.button>
        </div>
      </section>

      <section className="uiiuxx">
        <h2 className="fsh2 m1">SERVICES</h2>
        <h2 className="fsh3 m0 mb2">Custom Software services we offer</h2>
        <div className="serviceoffer">
          <div className="serviceoffer1">
            <div className="serviceoffer3">
              <div className="serviceoffer2">
                <img src="/images/image 76.webp" alt="" />
              </div>
              <div>
                <h2 className="serviceoffer4">Custom UI/UX Design</h2>
              </div>
            </div>
            <div className="serviceoffer3" style={{ marginRight: "200px" }}>
              <div className="serviceoffer2">
                <img src="/images/image 77.webp" alt="" />
              </div>
              <div>
                <h2 className="serviceoffer4">Custom web development</h2>
              </div>
            </div>
          </div>
          <div>
            <img className="girlhold" src="/images/girlhold.webp" alt="" />
          </div>
          <div className="serviceoffer1">
            <div className="serviceoffer3">
              <div className="serviceoffer2">
                <img src="/images/image 79.webp" alt="" />
              </div>
              <div>
                <h2 className="serviceoffer4">Custom App development</h2>
              </div>
            </div>
            <div className="serviceoffer3" style={{ marginLeft: "200px" }}>
              <div className="serviceoffer2">
                <img src="/images/image 79.webp" alt="" />
              </div>
              <div>
                <h2 className="serviceoffer4">Custom E-commerce development</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="whychooseus mainsec2 d-flex flex-column justify-content-center align-items-center m">
        <div className="text-start text-md-center d-flex flex-column align-items-left align-items-md-center justify-content-center mb2">
          <h2 className="fsh2 m0 mb2">Process</h2>
          <p className="fsh3 m0 mb2">Our Top Rated Custom software solutions Process</p>
        </div>

        <div className="row g-4">
          {features1.map((feature, index) => (
            <div key={index} className="col-md-10 col-lg-6">
              <div
                className="card shadow-sm p-3 h-100 d-flex flex-column justify-content-center align-items-center section2box"
                style={{ border: "2px solid #137eb1" }}
              >
                <div
                  className="d-flex justify-content-between justify-content-md-center align-items-center w-100"
                  onClick={() => isMobile && toggleAccordion(index)}
                  style={{ cursor: isMobile ? "pointer" : "default" }}
                >
                  <div className="d-flex flex-md-column align-items-center justify-content-center gap-3">
                    <div className="section2img">
                      <img
                        src={feature.img}
                        alt={feature.title}
                        className="card-img-top img-fluid"
                      />
                    </div>
                    <h5 className="fsh4">{feature.title}</h5>
                  </div>
                  <div>
                    {isMobile && (
                      <span className="fs-4">
                        {activeIndex === index ? "−" : "+"}
                      </span>
                    )}
                  </div>
                </div>

                <div
                  className={`card-body ${isMobile ? "accordion-content" : ""}`}
                  style={{
                    display: isMobile
                      ? activeIndex === index
                        ? "block"
                        : "none"
                      : "block",
                    transition: "all 0.3s ease"
                  }}
                >
                  <p className="fsp">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
          <div
            className="col-md-10 col-lg-6 d-flex flex-column justify-content-center 
 align-items-center"
          >
            <div className=" digtrans">
              <h2 className="mb-4" style={{ color: "white" }}>
                Start Your Digital Transformation With Us
              </h2>
              <button
                onClick={handleClicked}
                className="btn btn-primary px-4 py-2"
                style={{
                  backgroundColor: "white",
                  color: "#137eb1"
                }}
              >
                Connect With Us
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Customsoso;
